import HelperService from "../../../StarterKit/Service/Bll/HelperService";
import ApiObjectif from "../Api/ApiObjectif";

export default class ObjectifService {
    #helper;
    #api;

    constructor() {
        this.#api = new ApiObjectif();
        this.#helper = new HelperService();
    }


    async list() {
        const result = await this.#api.list();
        return result;
    }

    async listAll() {
        const result = await this.#api.listAll();
        return result;
    }

    async import(file) {
        const result = await this.#api.import(file);
        return result;
    }

    async importCommerciaux(file) {
        const result = await this.#api.importCommerciaux(file);
        return result;
    }
}
